(() => {
  if (window.StellarRegisteredMarks) return;
  window.StellarRegisteredMarks = true;
  const excluded = 'script,style,noscript,template,textarea,input,select,option,svg,math,pre,code,sup,[contenteditable]:not([contenteditable="false"]),[data-stellar-no-typeset]';
  const eligible = node => node.nodeType === Node.TEXT_NODE && node.data.includes('\u00ae') && node.parentElement && !node.parentElement.closest(excluded);
  const wrap = node => {
    const pieces = node.data.split('\u00ae');
    const fragment = document.createDocumentFragment();
    pieces.forEach((piece, index) => {
      if (index) {
        const mark = document.createElement('sup');
        mark.className = 'stellar-registered-mark';
        mark.textContent = '\u00ae';
        fragment.append(mark);
      }
      if (piece) fragment.append(document.createTextNode(piece));
    });
    node.replaceWith(fragment);
  };
  const scan = root => {
    if (root.nodeType === Node.TEXT_NODE) {
      if (eligible(root)) wrap(root);
      return;
    }
    if (root.nodeType !== Node.ELEMENT_NODE || root.closest(excluded)) return;
    const walker = document.createTreeWalker(root, NodeFilter.SHOW_ELEMENT | NodeFilter.SHOW_TEXT, {
      acceptNode(node) {
        if (node.nodeType === Node.ELEMENT_NODE) return node.matches(excluded) ? NodeFilter.FILTER_REJECT : NodeFilter.FILTER_SKIP;
        return eligible(node) ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_REJECT;
      }
    });
    const nodes = [];
    while (walker.nextNode()) nodes.push(walker.currentNode);
    nodes.forEach(wrap);
  };
  const start = () => {
    const pending = new Set();
    let frame = 0;
    const options = { childList: true, characterData: true, subtree: true };
    const flush = () => {
      frame = 0;
      observer.disconnect();
      for (const node of pending) if (node.isConnected) scan(node);
      pending.clear();
      observer.observe(document.body, options);
    };
    const observer = new MutationObserver(records => {
      for (const record of records) {
        if (record.type === 'characterData') {
          if (eligible(record.target)) pending.add(record.target);
        } else {
          for (const node of record.addedNodes) {
            if (node.nodeType === Node.TEXT_NODE ? eligible(node) : node.nodeType === Node.ELEMENT_NODE && !node.closest(excluded) && node.textContent.includes('\u00ae')) pending.add(node);
          }
        }
      }
      if (pending.size && !frame) frame = requestAnimationFrame(flush);
    });
    scan(document.body);
    observer.observe(document.body, options);
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
})();
